export default "/images/almbrand.avif?b79092abd87a6371194c65b32e6a4d1c";